import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button, Form } from "react-bootstrap";

import CustomFormCheck from "utils/CustomFormCheck";
import BackButton from "../BackButton";
import NextButton from "../NextButton";
import SkipButton from "../SkipButton";
import getNextPage from "../getNextPage";
import { RouterContext } from "../Onboarding";

export default function DataFeedWatchInstall(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);
  const [showBoxes, setShowBoxes] = useState(false);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);

  props.pageLocator();

  const [validated, setValidation] = useState(false);
  useEffect(() => {
    if (props.teamAccess["DataFeedWatch"]["Completed setup"] !== "1" && showBoxes) {
      setValidation(false);
    }
  });

  return (
    <>
      <Row className="px-lg-4 px-0 mb-2 pb-2 justify-content-center">
        <Col lg={7} md={10}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">DataFeedWatch Install</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              On this page you will install DataFeedWatch.{" "}
              <a href={"https://help.datafeedwatch.com/article/xsgi6yhcea-3202731-adding-shopify"} target="_blank">
                <strong>Please click here</strong>
              </a>{" "}
              to open a new tab with detailed instructions on how to set up properly, and then check the box to indicate that setup is done and the custom feed
              is configured.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="mb-1 px-lg-4 px-0  justify-content-center">
        <Col lg={4} md={6}>
          <div>
            <p className="f16 nunito-regular  primary ">Do we need to set up DataFeedWatch for this client?</p>
          </div>
        </Col>
      </Row>
      <Row className="mb-3 px-lg-4 px-0 pb-3 justify-content-center">
        <Col lg={4} md={6}>
          <div className="d-flex flex-column ">
            <Form.Check
              className="f16"
              name="ob-tracking"
              custom
              label="Yes."
              type="radio"
              id="ob-tracking-yes"
              onClick={() => {
                setShowBoxes(true);
                setValidation(true);
              }}
            />
            <Form.Check
              name="ob-tracking"
              className="f16"
              custom
              label="No"
              type="radio"
              id="ob-tracking-no"
              onClick={() => {
                setShowBoxes(false);
                setValidation(true);
              }}
            />
          </div>
        </Col>
      </Row>

      <Row className={`my-5 justify-content-center ${!showBoxes && "d-none"}`}>
        <Col lg={4} md={6}>
          <div className="p-4" style={{ backgroundColor: "#E1E1E1", marginTop: "14px" }}>
            <div className="pb-2 text-left">
              <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
              <CustomFormCheck
                id="ob_dfw_installed"
                name="dfw_installed"
                label="DataFeedWatch installed"
                checked={props.teamAccess["DataFeedWatch"] ? props.teamAccess["DataFeedWatch"]["Completed setup"] == "1" : "0"}
                disabled={props.teamAccess["DataFeedWatch"] ? props.teamAccess["DataFeedWatch"]["Standard"] == "1" : false}
                onChange={(e) => {
                  let accessChecked = props.teamAccess;
                  accessChecked["DataFeedWatch"]["Completed setup"] = props.teamAccess["DataFeedWatch"]["Completed setup"] == "1" ? "0" : "1";
                  accessChecked["DataFeedWatch"]["Completed setup"] == "1" && setValidation(true);
                  props.setTeamAccess({ ...accessChecked });
                }}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row className="pt-3 justify-content-center">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
